import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    usermain: {
      curOrg: {
        'name': 'None'
      },
      currentUser: {},
      rolesData: {},
      isOwner: false,
    },
  },
  mutations: {
    setCurOrg(state, curOrg) {
      state.usermain.curOrg = curOrg
    },
    setRolesData(state, rolesData) {
      state.usermain.rolesData = rolesData
    },
    setCurrentUser(state, currentUser) {
      state.usermain.currentUser = currentUser
    },
    setIsOwner(state, isOwner) {
      state.usermain.isOwner = isOwner
    },
  },
  getters: {
    hasRoles: (state) => (roles) => {
      return roles.every((role) => state.usermain.rolesData[role] != null || state.usermain.isOwner);
    },
  },
  actions: {},
  modules: {},
});
